import { componentOutletConfigFactory } from '@recruitee/common';

import { AdminsAvatarsComponent } from '../../common/admins-avatars/admins-avatars.component';
import type { DataTableRow, TableCellFactory } from '../data-table.types';
import { EMPTY_CELL } from './text-cell.component';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
*/

export class AdminAvatarsCellComponent extends AdminsAvatarsComponent {
  public static NgInputs = ['admins' as const];

  public admins: AdminsAvatarsComponent['admins'];
}

export const usersAvatarsCellFactory =
  <
    Key extends Extract<keyof Row, string | number>,
    Row extends DataTableRow & Record<Key, AdminsAvatarsComponent['admins']>,
  >(
    key: Key,
  ): TableCellFactory<Row> =>
  ({ row }) => {
    if (!row[key]?.length) return EMPTY_CELL;

    return componentOutletConfigFactory(AdminAvatarsCellComponent, {
      inputs: { admins: row[key] },
    });
  };
